module.exports = __webpack_public_path__ + "media/images/lp_banner_600_500_A-cec87d9ff797ecb2531f7288de694ab8.webp";